import React from 'react';

const ReadingTimeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M7.6 7V7.1H7.7H9.8C10.1314 7.1 10.4 7.36863 10.4 7.7C10.4 8.03137 10.1314 8.3 9.8 8.3H7C6.66863 8.3 6.4 8.03137 6.4 7.7V4.2C6.4 3.86863 6.66863 3.6 7 3.6C7.33137 3.6 7.6 3.86863 7.6 4.2V7ZM7 12.7C10.148 12.7 12.7 10.148 12.7 7C12.7 3.85198 10.148 1.3 7 1.3C3.85198 1.3 1.3 3.85198 1.3 7C1.3 10.148 3.85198 12.7 7 12.7ZM13.9 7C13.9 10.8108 10.8108 13.9 7 13.9C3.18923 13.9 0.1 10.8108 0.1 7C0.1 3.18923 3.18923 0.1 7 0.1C10.8108 0.1 13.9 3.18923 13.9 7Z"
        fill="#488EC8"
        stroke="white"
        strokeWidth="0.2"
      />
    </svg>
  );
};

export default ReadingTimeIcon;